import { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";

export type ExpandedFormControlProps = {
  initialWidth?: number,
  expandedWidth?: number,
  placeholder: string,
  value?: string,
  disabled: boolean,
}

export default function ExpandableFormControl({
    initialWidth = 200,
    expandedWidth = 400,
    value,
    placeholder,
    disabled,
  }: ExpandedFormControlProps
): JSX.Element {
  const [expanded, setExpanded] = useState(false);
  const toggleExpand = () => setExpanded(prev => !prev);
  const currentWidth = expanded ? expandedWidth : initialWidth;

  return (
    <InputGroup style={{ width: `${currentWidth}px`, transition: 'width 0.3s ease' }}>
      <Form.Control value={value} placeholder={placeholder} disabled={disabled} />
      <Button
        variant="outline-secondary"
        onClick={toggleExpand}
        style={styles.expandableButton}
        title={expanded ? 'Collapse' : 'Expand'}
        disabled={!value && placeholder.length === 0}
      >
        {expanded ? '<' : '>'}
      </Button>
    </InputGroup>
  );
};

const styles = {
  expandableButton: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  },
};
